










































import {ReportDataParseRequest} from "@/modules/cbc/models";
import {Component, Vue} from "vue-property-decorator";

@Component
export default class ReportDataParseComponent extends Vue {
	public dialog: boolean = false;
	public files: File[] = [];

	public onParse() {
		this.files.forEach(file => this.$emit("parse-file", {file: file} as ReportDataParseRequest));
		this.dialog = false;
		this.files = [];
	}
}
